import React from 'react';
import { format, subDays, subMonths, subYears } from 'date-fns';
import { KText } from '@/ui-library/components';

const dateMap = {
  past1d: 'Yesterday',
  past7d: 'Last Week',
  past30d: 'Last Month',
  past3m: 'Last Quarter',
  past12m: 'Last Year',
};

const getDateRange = (preset) => {
  const today = new Date();

  switch (preset) {
    case 'past1d':
      return { from: subDays(today, 1), to: today };
    case 'past7d':
      return { from: subDays(today, 7), to: today };
    case 'past30d':
      return { from: subDays(today, 30), to: today };
    case 'past3m':
      return { from: subMonths(today, 3), to: today };
    case 'past12m':
      return { from: subYears(today, 1), to: today };
    default:
      return { from: today, to: today };
  }
};

export const DateRange = ({ from = undefined, to = undefined }) => {
  if (!from && !to) return null;
  let displayText;

  if (dateMap[from]) {
    const { from: startDate, to: endDate } = getDateRange(from);
    displayText = `${dateMap[from]} (${format(
      startDate,
      'yyyy-MM-dd'
    )} - ${format(endDate, 'yyyy-MM-dd')})`;
  } else {
    const fromDate = new Date(from);
    displayText = format(fromDate, 'yyyy-MM-dd');
    if (to) {
      const toDate = new Date(to);
      displayText += ` - ${format(toDate, 'yyyy-MM-dd')}`;
    }
  }

  return <KText>{displayText}</KText>;
};
